import { Component, OnInit, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-add-edit-blog-category',
  templateUrl: './add-edit-blog-category.component.html',
  styleUrls: ['./add-edit-blog-category.component.css']
})
export class AddEditBlogCategoryComponent implements OnInit {
  category: any = {};

  constructor(private httpClient: HttpClient, public dialogRef: MatDialogRef<AddEditBlogCategoryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    if (this.data.category) {
      this.data.category.id = (this.data.category.id) ? this.data.category.id : ''
      this.data.category.name = (this.data.category.name) ? this.data.category.name : ''
    }
  }


  save(form) {
 
    if (form.invalid)
      return

    let categoryData: any = {
      'Name': this.data.category.name,
      'Name2': null,
    }
    if (this.data.category && this.data.category.id) {
      categoryData.id = this.data.category.id;
    }

    if (this.data.isDuplicate) {
      this.httpClient.post('/BolgArchive/DuplicateCategory/', { Name: form.value.Category, Id: this.data.category.id }).subscribe((res: any) => {
        this.dialogRef.close(true);
      });
    } else {
      this.httpClient.post('/Categories/SaveCategory/', categoryData).subscribe((res: any) => {
        this.dialogRef.close(true);
      });
    }


  }


  close() {
    this.dialogRef.close();
  }

}

